import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitEnquiry = (payload) => api.post("/enquiries", payload).then((r) => r.data);
export const submitFinanceApplication = (payload) =>
  api.post("/finance-applications", payload).then((r) => r.data);
